import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-pagekit', 'BrandPagekit', [["path",{"d":"M12.077 20h-5.077v-16h11v14h-5.077"}]]);